var _a;
import React from 'react';
import ReactDOM from 'react-dom';
import '@marvelapp/marvel-styleguide/dist/css/styleguide.css';
import createProtoypeViewer from '@marvelapp/prototype-viewer';
var injectedProject = (_a = window === null || window === void 0 ? void 0 : window.MARVELAPP) === null || _a === void 0 ? void 0 : _a.projectConfig;
if (injectedProject) {
    var PrototypeViewer = createProtoypeViewer({}, {
        areKeyboardControlsEnabled: function () { return true; },
        userIsAuthenticated: true,
        isDownloaded: true,
        isAppBuild: typeof Ti !== 'undefined',
    });
    PrototypeViewer.setProject(injectedProject);
    ReactDOM.render(React.createElement(PrototypeViewer, null), document.getElementById('root'));
}
